import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useResponsive } from '@garnish/core';
import { getIosModalPresentationConfig, ModalDialogue } from '@garnish/overlays';

import { HorizontalSafeAreaContainer } from '../HorizontalSafeAreaContainer';
import { LoadingAnimation } from '../LoadingAnimation';
import { AccountDeletionSecondStep } from './components';
import { useAccountDeletion, useAccountDeletionContentfulData } from './hooks';

export const RequestAccountDeletionModal = (props: RequestAccountDeletionModalProps) => {
  const { visible, onClose, onSuccess } = props;

  const { currentBreakpoint, match } = useResponsive();

  const sheetPresentationConfig = currentBreakpoint.isXS ? getIosModalPresentationConfig() : undefined; // prettier-ignore
  const { formatMessage } = useIntl();

  const { body, isLoadingContentfulData } = useAccountDeletionContentfulData();

  const { isDeletingAccount, requestAccountDeletion } = useAccountDeletion({
    onClose,
    onSuccess,
  });

  return (
    <ModalDialogue
      size={match(['full', 'medium'])}
      accessibilityLabel={formatMessage(messages.accountDeleteHeadline)}
      visible={visible}
      onRequestClose={onClose}
      fitHeight
      {...sheetPresentationConfig}
    >
      <HorizontalSafeAreaContainer>
        {isLoadingContentfulData ? (
          <LoadingAnimation />
        ) : (
          <AccountDeletionSecondStep
            body={body}
            isDeletingAccount={isDeletingAccount}
            requestAccountDeletion={requestAccountDeletion}
          />
        )}
      </HorizontalSafeAreaContainer>
    </ModalDialogue>
  );
};

type RequestAccountDeletionModalProps = Readonly<{
  visible: boolean;
  onSuccess: () => void;
  onClose: () => void;
}>;

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountDeleteHeadline: {
    defaultMessage: 'Delete account',
    description: 'Account | Delete | Headline',
  },
});
